export const costcoContext = {
  channel: "COSTCO",
  type: "partner",
  mappings: [
    {
      key: "default",
      useDefault: true,
      isGeneric: true,
      useReportingData: false,
      url: "/",
      categoryId: "COSTCO_MICRO",
      page_key: "DEFAULT",
      reportingData: {},
    }   
  ]
};
